
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { SweepstakesEntry } from './useSweepstakesData';

export const useSweepstakesEntries = () => {
  const { t } = useTranslationUtils();
  const { toast } = useToast();
  const [entries, setEntries] = useState<SweepstakesEntry[]>([]);
  const [loadingEntries, setLoadingEntries] = useState(false);
  const [selectedSweepstakesId, setSelectedSweepstakesId] = useState<string | null>(null);

  const fetchEntries = async (sweepstakesId: string) => {
    if (!sweepstakesId) return;
    
    try {
      setLoadingEntries(true);
      setSelectedSweepstakesId(sweepstakesId);
      
      const { data, error } = await supabase
        .from('sweepstakes_entries')
        .select(`
          *,
          customer_profiles:customer_id (
            id, first_name, last_name, email, points_balance, tier
          )
        `)
        .eq('sweepstakes_id', sweepstakesId);
        
      if (error) throw error;
      setEntries(data || []);
    } catch (error) {
      console.error('Error fetching entries:', error);
      toast({
        title: t('admin.error'),
        description: t('admin.errorFetchingEntries', 'Error fetching sweepstakes entries'),
        variant: 'destructive',
      });
    } finally {
      setLoadingEntries(false);
    }
  };

  return {
    entries,
    loadingEntries,
    selectedSweepstakesId,
    fetchEntries
  };
};
